module.exports = __webpack_public_path__ + "static/media/goodnest_app1_preview.2c9124b6.jpg";